<div class="column-filter-wrapper">
  <button
    mat-icon-button
    type="button"
    [matMenuTriggerFor]="filterMenu"
    #menuTrigger="matMenuTrigger"
    class="filter-button"
    [class.active]="isActive"
    [attr.aria-label]="filterButtonAriaLabel"
    (click)="onButtonClick($event)"
    (keydown)="onButtonKeydown($event)"
  >
    <mat-icon fontIcon="filter_list" aria-hidden="true"></mat-icon>
    @if (badgeCount > 0) {
      <span class="filter-badge">{{ badgeCount }}</span>
    }
  </button>

  <mat-menu #filterMenu="matMenu" class="column-filter-menu" [overlapTrigger]="false" (opened)="onMenuOpened()">
    <div
      class="filter-menu-content"
      tabindex="-1"
      (click)="$event.stopPropagation()"
      (keydown)="onMenuContentKeydown($event)"
    >
      <div class="filter-header">
        <span class="header-title">Filter by {{ config.columnLabel }}</span>
      </div>

      <app-column-filter-editor
        #editor
        [config]="config"
        [criterion]="criterion"
        (criterionChange)="onCriterionChange($event)"
      ></app-column-filter-editor>

      <div class="button-row">
        <button mat-button type="button" color="primary" (click)="clearFilter()" [disabled]="!isActive">Clear</button>
        <button mat-button type="button" color="primary" (click)="closeMenu()">Close</button>
      </div>
    </div>
  </mat-menu>
</div>
